<template>

</template>

<script>
export default {
  name: "PaginationDefaultLayout"
}
</script>

<style scoped>

</style>